export default __webpack_public_path__ + "static/media/E50.28540e6d.jpg";